import { render, staticRenderFns } from "./edit.timeline-lists.page.vue?vue&type=template&id=1f8aa54c&"
import script from "./edit.timeline-lists.page.vue?vue&type=script&lang=js&"
export * from "./edit.timeline-lists.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports